import { connect } from 'react-redux';

import { loginUserAction } from '../actions/userActions';
import Login from '../components/User/Login/loginView';
import {
  getErrors,
  getLoading,
  getMessage,
  getSuccessful,
} from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  errors: getErrors(state),
  successful: getSuccessful(state),
  message: getMessage(state),
  isLoading: getLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  login: (email, password, rememberMe) => {
    dispatch(loginUserAction(email, password, rememberMe));
  },
});

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);

export default LoginContainer;
